import React from 'react';
import Button from '../utility/Button';
import ButtonLink from '../utility/ButtonLink';
import iconLocation from '../../images/icons/icon_32_location.png';
import iconPax from '../../images/icons/icon_32_noofpax.png';
import iconDriver from '../../images/icons/icon_driver.png';
import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';
import { PropTypes } from 'prop-types';
import { withTranslation } from 'react-i18next';

import { formatDate, ellipsis } from '../../js/utility';

import { MAX_NAME_DISPLAY_LENGTH as maxNameLength } from '../../constants';

const renderCompanions = (travellers, t) =>
  [...Array(travellers.length > 4 ? 4 : travellers.length)].map((_, idx) => {
    if (travellers.length > 4 && idx === 3) {
      return (
        <div key={idx} className='fe-my-booking-item-companion'>
          <img src={iconPax} alt='' />
          <span>
            {t('trip:numOthers', { num: `+${travellers.length - 3}` })}
          </span>
        </div>
      );
    } else if (travellers[idx].name === null) {
      return (
        <div key={idx} className='fe-my-booking-item-companion unfilled'>
          <img src={travellers[idx].is_driver ? iconDriver : iconPax} alt='' />
          <span>{t('trip:toFill')}</span>
        </div>
      );
    }
    return (
      <div key={idx} className='fe-my-booking-item-companion'>
        <img src={travellers[idx].is_driver ? iconDriver : iconPax} alt='' />
        <span>{ellipsis(travellers[idx].name, maxNameLength)}</span>
      </div>
    );
  });

const BookingItem = ({ booking, t, handleDelete }) => {
  return (
    <div className='fe-my-booking-item-container'>
      <div className='fe-my-booking-item'>
        {booking.upcoming ? (
          <div className='fe-my-booking-item-time-left'>
            {booking.days_left}
          </div>
        ) : null}
        <div className='fe-my-booking-item-img'>
          <div className='fe-my-booking-item-location'>
            <div className='fe-my-booking-item-time'>{`${formatDate(
              booking.date
            )}, ${booking.time.toUpperCase()}`}</div>
            <div className='fe-my-booking-item-place'>{booking.location}</div>
          </div>
          <img
            className='fe-my-booking-item-img-desktop'
            src={booking.photo_cover.desktop_view}
            alt=''
          />
          <img
            className='fe-my-booking-item-img-mobile'
            src={booking.photo_cover.mobile_view}
            alt=''
          />
        </div>
        <div className='fe-my-booking-item-info'>
          <h2 className='fe-my-booking-item-title'>{booking.trip}</h2>
          {!booking.byor && (
            <div className='fe-my-booking-item-meeting-point'>
              <img src={iconLocation} alt='' />
              <span>{booking.meeting_point}</span>
            </div>
          )}
          <div className='fe-my-booking-item-vehicle'>
            {!booking.byor ? (
              <div className='fe-my-booking-item-vehicle-thumb'>
                <div className='fe-u-thumb-3by1'>
                  <img src={booking.img_url} alt='' />
                </div>
              </div>
            ) : (
              <img className='fe-my-booking-item-byoc' src={iconBYOC} alt='' />
            )}
            <span>
              {!booking.byor ? (
                booking.model
              ) : (
                <>
                  {t('gen:vehicleNo')}
                  <b>{booking.vehicle_registration_no}</b>
                </>
              )}
            </span>
          </div>
          <div className='fe-my-booking-item-btm'>
            <div className='fe-my-booking-item-travelling'>
              <h3 className='fe-my-booking-item-companions-title'>
                {t('trip:whoTravelling')}
              </h3>
              <div className='fe-my-booking-item-companions'>
                {renderCompanions(booking.travellers, t)}
              </div>
            </div>
            <div className='fe-my-booking-item-view-details'>
              <div className={`fe-my-booking-item-status ${booking.status}`}>
                {booking.booking_status}
              </div>
              <div className='fe-my-booking-item-buttons'>
                {/* {booking.is_editable ? (
                  <ButtonLink
                    to={`/your-bookings/edit/${booking.uuid}`}
                    className='fe-my-booking-item-extra-btn'
                    alt
                  >
                    {t('form:editDetails')}
                  </ButtonLink>
                ) : null} */}
                {booking.review ? (
                  <ButtonLink
                    to={`/leave-a-review/${booking.uuid}`}
                    className='fe-my-booking-item-extra-btn fe-u-btn'
                    
                  >
                    {t('trip:leaveAReview')}
                  </ButtonLink>
                ) : null}
                {!booking.is_save_later ? (
                  <>
                    <ButtonLink to={`/your-bookings/${booking.uuid}`}
                    className='fe-u-btn'>
                      {t('trip:viewDetails')}
                    </ButtonLink>
                  </>
                ) : (
                  <>
                    <Button
                      className='delete'
                      onClick={() => handleDelete(booking.save_later_uuid)}
                      alt
                    >
                      {t('gen:delete')}
                    </Button>
                    <ButtonLink
                      to={`/booking/${booking.slug}/${booking.save_later_uuid}`}
                      alt
                    >
                      {t('trip:contBooking')}
                    </ButtonLink>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BookingItem.propTypes = {
  booking: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired
};

export default withTranslation()(BookingItem);
